import React from 'react'
import { useAppDispatch, useAppSelector } from 'app/hooks'
import { Trans, useTranslation } from 'react-i18next'
import { usePageConfigUser } from 'hooks/usePageConfig'
// @ts-ignore
import { Dialog } from '@netbasequid/core'
import { useDisplayTheme } from 'hooks/useUiState'
import { closeScheduledReportUnsubscriptionModal } from 'features/scheduledReport/scheduledReportSlice'
import { unsubscribeDashboardAlerts } from 'features/scheduledReport/asyncThunks'
import { useDashboardData } from 'hooks/useDashboardState'
import {
  selectIsUnsubscribeModalOpen,
  selectIsSubscribeStatusLoading
} from 'features/scheduledReport/selectors'
import SavingButton from 'components/visualization/SavingButton'
import { StyledSemiboldText } from './index.css'

const ReportUnsubscriptionModal = ({ dashboardId }: { dashboardId: number }) => {
  const theme = useDisplayTheme()
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const dashboardData = useDashboardData()
  const { email } = usePageConfigUser()

  const isOpen = useAppSelector(selectIsUnsubscribeModalOpen)
  const isLoading = useAppSelector(selectIsSubscribeStatusLoading)

  const onClose = () => {
    dispatch(closeScheduledReportUnsubscriptionModal())
  }

  return (
    <Dialog mode={theme} open={isOpen} onClose={onClose} disableBackdropClick width="600px">
      <Dialog.DialogTitle>{t('confirmUnsubscription')}</Dialog.DialogTitle>
      <Dialog.DialogContent>
        <Trans
          tOptions={{ interpolation: { escapeValue: false } }}
          i18nKey="unsubscriptionModalMsg"
          values={{ email, dashboardName: dashboardData?.name }}>
          <StyledSemiboldText />
        </Trans>
      </Dialog.DialogContent>
      <Dialog.DialogActions
        okButtonProps={{
          disabled: isLoading,
          children: isLoading ? <SavingButton /> : t('unsubscribe'),
          onClick: () => {
            dispatch(unsubscribeDashboardAlerts(dashboardId)).then((resultAction) => {
              if (unsubscribeDashboardAlerts.fulfilled.match(resultAction)) {
                onClose()
              }
            })
          }
        }}
        closeButtonProps={{
          color: 'secondary',
          children: t('cancel')
        }}
      />
    </Dialog>
  )
}

export default ReportUnsubscriptionModal
